import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ce-layout-footer-container',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './footer-container.component.html',
    styleUrl: './footer-container.component.scss',
})
export class FooterContainerComponent {}
